'use client';

import { useEffect } from 'react';

export default function PwaRegistry() {
  useEffect(() => {
    if (process.env.NODE_ENV !== 'production') {
      return;
    }

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js')
        .then((registration) => {
          console.log('[PWA Registry] Service Worker registered with scope:', registration.scope);
        })
        .catch((error) => {
          console.error('[PWA Registry] Service Worker registration failed:', error);
        });
    }
  }, []);

  return null; // This component does not render anything.
}
